// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const DropSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 178 178"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path fill="none" d="M0 0h177.63v177.63H0z" />
      <path
        d="M16.047 25.498l141.634-.698-71.213 71.213-70.421-70.515z"
        fill="none"
        stroke={props.fill}
        strokeWidth={9.29}
        transform="matrix(1.0849 0 0 1.06791 -5.159 33.817)"
      />
    </svg>
  )
}
